import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

interface Category {
  appCategoryId: number;
  appCategoryName: string;
}

interface ListCategoryProps {
  categoriesList: {
    appCategoryId: number;
    appCategoryName: string;
  }[];
}

const ListCategories: React.FC<ListCategoryProps> = ({ categoriesList }) => {
  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>App Categories</th>
          </tr>
        </thead>
        <tbody>
          {categoriesList.map((category: Category, index: number) => (
            <tr key={category.appCategoryId}>
              <td>
                <Link to={`${category.appCategoryId}`}>{category.appCategoryId}</Link>
              </td>
              <td>
                <Link to={`${category.appCategoryId}`}>{category.appCategoryName}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ListCategories;
